import { connect } from 'react-redux'
import { fetchStates, fetchStatesSuccess, fetchStatesFailure } from '../actions/states';
import StatesList from '../components/States';

const mapStateToProps = (state) => {
    return { 
        statesList: state.states.statesList
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchStates: () => {
            dispatch(fetchStates()).then((response) => {
                !response.error ? dispatch(fetchStatesSuccess(response.payload.data)) : dispatch(fetchStatesFailure(response.payload.data));
            });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(StatesList);



/** WEBPACK FOOTER **
 ** ./src/containers/StatesContainer.js
 **/